import script from "./CrosswordTile.vue?vue&type=script&setup=true&lang=js"
export * from "./CrosswordTile.vue?vue&type=script&setup=true&lang=js"

import "./CrosswordTile.vue?vue&type=style&index=0&id=7cf591be&scoped=true&lang=css"

import exportComponent from "C:\\Cwiczenia Programowanie Wojtek\\Vue Shop-FCC\\lang-cross\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf591be"]])

export default __exports__